export const WEBSITE_PAGES = {
  "/": "/website/index.html",
  "/clients": "/website/clients/index.html",
  "/contact": "/website/contact/index.html",
  "/services": "/website/services/index.html",
  "/get-your-moments": "/website/get-your-moments/index.html?v=4",
};

export const WEBSITE_PATHS = Object.keys(WEBSITE_PAGES);

export const isWebsitePath = (pathname) => WEBSITE_PATHS.includes(pathname);
